/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import FilterCalendar from "./calendar/calendar.jsx";
import StoreFilter from "./storeFilter";
import Daysofweek from "./daysofweek.jsx";
import GroupFilter from "./groupsFilter";

import { fetchStoreData } from "../../core/redux/stores/stores.action.jsx";
import {
  setKpiData,
  setKpiData2,
} from "../../core/redux/filters/filter.action.jsx";
import { APIKpis } from "../../api/authSSO.ts";
import { useDispatch } from "react-redux";

const FilterBar = () => {
  const urlExport = window.location.href.includes("export-data");
  // const accessToken = localStorage.getItem("accessToken") || 'bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJkb1lIcnVyZGVrTU5hZGtKTiIsImFjY2Vzc1Rva2VuRXhwIjp7ImRhdGUiOiIyMDI0LTA3LTA2IiwidGltZSI6IjIwOjM0OjQyIiwidGltZVN0YW1wIjoxNzIwMjY1NjgyMDkwLCJnbXQiOiIrMDkwMCJ9LCJyZWZyZXNoVG9rZW5FeHAiOnsiZGF0ZSI6IjIwMjQtMDctMDYiLCJ0aW1lIjoiMjA6MzQ6NDIiLCJ0aW1lU3RhbXAiOjE3MjAyNjU2ODIwOTAsImdtdCI6IiswOTAwIn0sImlhdCI6MTcxNzY3MzY4MiwiZXhwIjoxNzE3NjczNzQyfQ.G5Jwt86wWbu1Lec--ZrZlTXwOgFGA7bKhtk-xZLhE8k';
  const accessToken = "Bearer " + localStorage.getItem("accessToken"); //Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJ0ekpFTlNxcDJXeXh4YlNGbSIsImFjY2Vzc1Rva2VuRXhwIjp7ImRhdGUiOiIyMDI0LTA3LTE2IiwidGltZSI6IjAyOjQyOjU2IiwidGltZVN0YW1wIjoxNzIxMDY1Mzc2OTQ0LCJnbXQiOiIrMDkwMCJ9LCJyZWZyZXNoVG9rZW5FeHAiOnsiZGF0ZSI6IjIwMjQtMDctMTYiLCJ0aW1lIjoiMDI6NDI6NTYiLCJ0aW1lU3RhbXAiOjE3MjEwNjUzNzY5NDUsImdtdCI6IiswOTAwIn0sImlhdCI6MTcxODQ3MzM3NiwiZXhwIjoxNzE4NDczNDM2fQ.QQZ-cUD7Od5sNhdrT76yXvCSmv7d41_yt-1Lc_Ndxck';
  const dispatch = useDispatch();
  // useEffect(async() => {
  //   dispatch(fetchStoreData(accessToken));

  //   const kpisList = await APIKpis();
  //   //const allkpis = allkpis.filter(item => item !== "dm");
  //   // have to comment this , and un comment above line
  //   const allKpis = kpisList.response
  //     .map(item => item.key)
  //     .filter(key => !key.includes('.') && key !== 'dm' && ["sls", "trf", "trn", "ap", "aip", "upt", "is", "pb"].includes(key));

  //   dispatch(setKpiData2({ listKpis2: allKpis }));

  //   const kpisArray = allKpis.slice(0, 4);

  //   dispatch(setKpiData({ kpisSelected: kpisArray }));

  // }, [dispatch]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(fetchStoreData(accessToken));
        const kpisList = await APIKpis();
        var allKpis = kpisList?.response?.map((item) => item.key);
        allKpis = allKpis.filter(
          (kpi) => kpi !== "trf" && kpi !== "dm" && kpi !== "bug"
        );
        dispatch(setKpiData2({ listKpis2: allKpis }));
        const kpisArray = allKpis.slice(0, 4);
        dispatch(setKpiData({ kpisSelected: kpisArray }));
      } catch (error) {
        console.error("Error fetching KPI or store data:", error);
      }
    };

    fetchData();
  }, [dispatch, accessToken]); // Added accessToken to dependencies

  return (
    <div className="filter-main-wrapper">
      <div className="filter-wrapper">
        <div className="filter-inner">
          <span style={{ display: urlExport ? "none" : "inline" }}>
            <Daysofweek />
          </span>
          <StoreFilter />
          <GroupFilter />
        </div>
        <FilterCalendar />
      </div>
    </div>
  );
};

export default FilterBar;
